import { placeholderMap } from "../../data/placeholder.js";
import { getDateTimeParts } from "../get-date-time-parts/get-date-time-parts.js";
const generatePlaceholderString = (formattedReturn) => {
    return formattedReturn
        .map(({ type, value }) => {
        const char = placeholderMap[type];
        const count = value.length;
        if (type === "dayPeriod" || type === "era") {
            return value;
        }
        if (char) {
            return char.repeat(count);
        }
        return value;
    })
        .join("");
};
/**
 * Get text placeholder text for datetime
 * @param {Date | number} date dateTime object, defaults to now if not set
 * @param {string | string[]} locale country code, BCP 47 language string, or array of either - default to 'en-US' if not set
 * @param {BetterDateTimeFormatOptions} options standard dateTimeFormat options object
 *  reference at https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @returns {string} representation of localized placeholder text
 */
export const getPlaceholder = (date, locale, options) => {
    const formattedReturn = getDateTimeParts(date, locale, options);
    return generatePlaceholderString(formattedReturn);
};
